import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../../common/classes/entityComposition';
import { labelSelector, valueSelector, enabledSelector, newPathSelector } from '../selectors';
// import the just the picker field, not the composed picker field.
import { UncomposedSinglePickerField as SinglePickerField } from './singlePickerField';
import logValueOnChange from '../commonActions/logValueOnChange';
const DeprecatedFormPickerField = _ref => {
  let format = _ref.format,
    onChange = _ref.onChange,
    serverFilter = _ref.formActions.serverFilter,
    _ref$form = _ref.form,
    indexQuery = _ref$form.indexQuery,
    forms = _ref$form.list,
    formType = _ref.formType,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    enabled = _ref.enabled,
    path = _ref.path;
  const formsWithTitles = forms.map(r => ({
    id: r.id,
    title: r.title
  }));
  // load the available forms when component mounts
  useEffect(() => {
    serverFilter({
      formTypeIdentifiers: [formType]
    }, indexQuery, true);
  }, [formType, indexQuery, serverFilter]);
  return /*#__PURE__*/React.createElement(SinglePickerField, {
    format: format,
    onChange: onChange,
    options: formsWithTitles,
    value: value,
    valueKey: "id",
    label: label,
    enabled: enabled,
    path: path
  });
};
DeprecatedFormPickerField.propTypes = {
  format: PropTypes.shape({
    label: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  form: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  formActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  formType: PropTypes.string.isRequired,
  value: PropTypes.shape({}),
  label: PropTypes.string,
  path: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired
};
export { DeprecatedFormPickerField as UncomposedDeprecatedFormPickerField };
export default entityComposition(DeprecatedFormPickerField, ['form'], {
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  path: newPathSelector,
  onChange: logValueOnChange
});